function getProductTotalsHTML(label, qty) {
    "use strict";

    return `
        <div class="pull-left cart-modal__totals">
            <span class="cart-modal__quantity-label">${label}</span>
            <span class="quantity">${qty}</span>
        </div>
    `;
}

function getOutOfStockHTML(label) {
    "use strict";

    return `<div class="out-of-stock-warning">
        <span>${label}</span>
    </div>`;
}

function renderProductTotals(quantity, outOfStock) {
    "use strict";

    return outOfStock ?
        getOutOfStockHTML(TYROOLA.translations['header-cart-out-of-stock']) :
        getProductTotalsHTML(TYROOLA.translations['header-cart-quantity'], quantity);
}

export default renderProductTotals;